const GC = window.__GENERATED_CONSTANTS__

export const PROJECT_CONSTANTS = {
    SELECT_CUSTOMER_OPTION_INDEX: GC.PROJECT_CONSTANTS.SELECT_CUSTOMER_OPTION_INDEX,
    NEW_CUSTOMER_OPTION_INDEX: GC.PROJECT_CONSTANTS.NEW_CUSTOMER_OPTION_INDEX,
    CUSTOMER_WAS_ARCHIVED: GC.PROJECT_CONSTANTS.CUSTOMER_WAS_ARCHIVED,
    CUSTOMER_WAS_DELETED: GC.PROJECT_CONSTANTS.CUSTOMER_WAS_DELETED,
    USERS_WAS_DELETED: GC.PROJECT_CONSTANTS.USERS_WAS_DELETED,
    RESULT_CODE_SUCESS: GC.PROJECT_CONSTANTS.RESULT_CODE_SUCCESS

}



// WEBPACK FOOTER //
// ./web/js/taskManagement/createLightbox/project/constants.js